import { AfterViewChecked, AfterViewInit, Directive, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

const MAX_HEIGHT_IN_PX = 192;

// this directive should contain only plain text without markup
@Directive({
  selector: '[appHideText]'
})
export class HideTextDirective implements AfterViewChecked {
  private isHidden: boolean;
  private isChecked: boolean;

  viewMoreEl: HTMLElement = this.getViewMoreEl;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId) && !this.isChecked) this.checkVisibility();
  }

  protected checkVisibility() {
    const hostHeight = (<HTMLElement>this.el.nativeElement).getBoundingClientRect().height;
    this.isChecked = true;
    if (hostHeight < MAX_HEIGHT_IN_PX) {
      if (this.isHidden) return this.setVisible();
      else return;
    } else return this.setHidden();
  }

  private setHidden() {
    this.renderer.setStyle(this.el.nativeElement, 'max-height', `${MAX_HEIGHT_IN_PX}px`);
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');

    (<HTMLElement>this.el.nativeElement).appendChild(this.viewMoreEl);
    this.isHidden = true;
  }

  private setVisible() {
    this.renderer.setStyle(this.el.nativeElement, 'max-height', 'unset');
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'initial');
    this.renderer.removeChild(this.el.nativeElement, this.viewMoreEl);
    this.isHidden = false;
  }

  show() {
    this.setVisible();
  }

  private get getViewMoreEl(): HTMLElement {
    const viewMoreEl: HTMLElement = this.document.createElement('a');
    viewMoreEl.innerHTML = 'Показать ещё';
    this.renderer.addClass(viewMoreEl, 'hide-text-button');
    this.renderer.addClass(viewMoreEl, 'px-3');
    this.renderer.setAttribute(viewMoreEl, 'role', 'button');
    viewMoreEl.addEventListener('click', this.show.bind(this));
    return viewMoreEl;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/hide-text.directive.ts